import React, { useEffect } from "react";
import { FaMailBulk,FaFacebookSquare,FaInstagramSquare,FaPinterestSquare, FaLinkedin,FaPhoneAlt,FaMapMarkerAlt } from "react-icons/fa";
import {Link, NavLink, useLocation} from "react-router-dom";
export const Header = () => {
   const MenuOpen = () =>{
     const bar = document.getElementById("menu");
     bar.classList.toggle('shownav');
   }
   const SubMenuOpen = () =>{
    const bar = document.getElementById("mega-menu");
    bar.classList.toggle('submenushow')
  }

  const location = useLocation();
   useEffect(()=>
   {
     if(location.pathname === "/"){
          document.title ="Home";
     }
     else if(location.pathname === "/about"){
       document.title ="About";
          const contact = document.getElementById("contact");
          contact.style.marginTop = "170px";
          contact.style.marginBottom  = "170px";
          const gbtn = document.getElementById("glbl-btn");
          gbtn.style.display ="none";

          const mediaQuery = window.matchMedia('(max-width: 575px)')
          function handleTabletChange(e) {
            if (e.matches) {
                  contact.style.marginTop = "28px";
                contact.style.marginBottom  = "0px";  
            }
          }
           mediaQuery.addListener(handleTabletChange)
           handleTabletChange(mediaQuery)
     }
     else if(location.pathname === "/services"){
       document.title ="Services";
       const service = document.getElementById("service");
       service.style.marginTop = "70px";
       service.style.marginBottom = "0px";
       const servicebox = document.getElementById("service").getElementsByClassName("service-box")[18];
       servicebox.style.marginBottom = "0px";
       
      
      //  responsive media query starst here
       const mediaQuery = window.matchMedia('(max-width: 575px)')
       function servuceTabletChange(e) {
         if (e.matches) {
          service.style.marginTop = "40px";
          service.style.marginBottom = "-700px";
         }
       }
        mediaQuery.addListener(servuceTabletChange)
        servuceTabletChange(mediaQuery)

        //  responsive media query ends here

      
     }
     else if(location.pathname === "/industries"){
        document.title = "Industries";
         
      //  responsive media query starst here
       const mediaQuery = window.matchMedia('(max-width: 575px)')
       function servuceTabletChange(e) {
         if (e.matches) {
          const industries = document.getElementById("industries");
         industries.style.marginTop = "40px";
         industries.style.marginBottom = "-700px";
         }
       }
        mediaQuery.addListener(servuceTabletChange)
        servuceTabletChange(mediaQuery)

        //  responsive media query ends here
     }
     else if(location.pathname === "/contact"){
        document.title = "Contact";
        const contact = document.getElementById("contact");
        contact.style.marginTop = "130px";

          //  responsive media query starst here
       const mediaQuery = window.matchMedia('(max-width: 575px)')
       function servuceTabletChange(e) {
         if (e.matches) {
          contact.style.marginTop = "40px";
          contact.style.marginBottom = "7px";
         }
       }
        mediaQuery.addListener(servuceTabletChange)
        servuceTabletChange(mediaQuery)
        //  responsive media query ends here
    }
   },[location])
  return (
    <header>
      <div className="top-bar">
        <div className="container">
          <div className="flex spce-btwn">
            <div className="left flex spce-btwn align-center">
            <div className="mail-phone flex align-center">
              <FaMailBulk />
              <p>info@techsaga.com.au</p>
            </div>
            <div className="mail-phone flex align-center">
              <FaPhoneAlt />
              <p> +61412411283</p>
            </div>
            <div className="mail-phone flex align-center">
              <FaMapMarkerAlt/>
              <p>
                "106, Anniversary Avenue, Wyndham Vale - 3024. Victoria,
                Australia"
              </p>
            </div>
            </div>
            <div className="social-icons flex align-center ">
            <a href="/"><FaFacebookSquare/></a>
            <a href="/"><FaInstagramSquare/></a>
            <a href="/"><FaPinterestSquare/></a>
            <a href="/"><FaLinkedin/></a>
            </div>
          </div>
        </div>
      </div>
      {/* nav starts here */}

          <div className="container">
        
                <nav className="flex spce-btwn align-center">
                <div className="logo">
                  <NavLink to="/techsagaus" ><img src="./Assets/img/techsagalogo.png" alt="logo" className="img-fluid"/></NavLink>
                </div>
                <div className="menu" >
                     <ul id="menu">
                        <li><NavLink to="/techsagaus" >Home</NavLink></li>
                        <li><NavLink to="/about" >About</NavLink></li>
                        <li id="openService" onClick={()=>SubMenuOpen()}><NavLink to="/services" >Services <img src="./Assets/icons/down.png" alt="" /></NavLink>
                           <div className="mega-menu" id="mega-menu">
                               <div className="flex spce-btwn">
                                   <ul>
                                     <li><Link to="/agile">Agile Transformation</Link></li>
                                     <li><a href="">Devops Methodology</a></li>
                                     <li><a href="">Application Development</a></li>
                                     <li><a href="">Application Maintenance</a></li>
                                     <li><a href="">IOT Development</a></li>
                                   </ul>
                                   <ul>
                                   <li><a href="">Startup It Support</a></li>
                                   <li><a href="">Smart Automation Strategies</a></li>
                                   <li><a href="">Managed Outsourcing Service</a></li>
                                   <li><a href="">Influential Marketing</a></li>
                                   <li><a href="">Digital Marketing</a></li>
                                   </ul>
                                   <ul>
                                   <li><a class="" href="/blockchaindevelopment">BlockChain Development</a></li>
                                   <li><a href="">Startup Incubation</a></li>
                                   <li><a href="">Software Design And Development</a></li>
                                   <li><a href="">Online Reputation Managment</a></li>
                                   <li><a href="">Digital Consultation</a></li>
                                   </ul>
                                   <ul>
                                   <li><a href="">Improved ROI</a></li>
                                   <li><a href="">Hire Developer</a></li>
                                   <li><a href="">Integrated Brand Management</a></li>
                                   <li><a href="">Reduce Infrastructure Cost</a></li>
                            
                                   </ul>
                               </div>
                           </div>
                            
                  
                        </li>
                        <li><NavLink to="/industries" >Industries</NavLink></li>
                        <li>Blog</li>
                        <li><NavLink to="/contact" className="glbl-btn">Get a Quote</NavLink></li>
                     </ul>

                </div>
                <div class="burger-menu" onClick={()=>MenuOpen()}>
                       <span className="tggl"></span>
                       <span className="tggl"></span>
                       <span className="tggl"></span>
                </div>
                </nav>
           
          </div>

    </header>
  );
};
